import React from "react";
import HypenaNav from "./HypenaNav";

const LayoutHeader = () => <HypenaNav />;

export default LayoutHeader;
